<template>
  <aside class="sidebar">
    <div class="sidebar__pharmaflix-brand">
      <PharmaflixSVG class="pharmaflix-brand" />
    </div>
    <TheMenu />
    <base-link
      class="sidebar__bottom-aligned"
      color="white"
      :isRouterLink="true"
      :path="{ name: 'legalTerms' }"
    >
      <!-- Just to fix a bad formatting by prettier -->
      Mentions Légales
    </base-link>
  </aside>
</template>

<script>
import PharmaflixSVG from "@/assets/svg/pharmaflix.svg"
import TheMenu from "./TheMenu.vue"

export default {
  components: {
    TheMenu,
    PharmaflixSVG
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.sidebar {
  position: relative;
  z-index: 8;
  background-color: $color-primary;
  background-color: var(--color-primary, $color-primary);
  color: white;
  text-align: left;
  display: flex;
  text-transform: uppercase;
  flex-flow: column wrap;
  text-transform: uppercase;
  box-shadow: 4px -1px 21px 0px rgba(0, 0, 0, 0.31);
  &__pharmaflix-brand {
    margin: 34px auto 0;
    width: 80%;
    max-width: 180px;
    text-align: right;
    .pharmaflix-brand {
      text-transform: initial;
      margin-bottom: -6px;
    }
    &__beta {
      color: $color-secondary;
      font-family: "Muli", Arial, Helvetica, sans-serif;
      font-weight: 800;
      font-style: italic;
      font-size: 14px;
      display: inline;
      text-transform: lowercase;
    }
  }

  &__bottom-aligned {
    text-transform: capitalize;
    font-size: 12px;
    text-align: center;
    margin-top: auto;
    margin-bottom: 18px;
  }
}
</style>
